import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between w-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "mb-5 text-4xl font-bold text-primary-700 lg:mb-0" }, "Your Test Results", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "absolute top-0 right-0 w-4 h-4 bg-red-700 border-4 border-white rounded-full has-notif" }, null, -1)
const _hoisted_4 = { class: "mb-5 text-neutral-700" }
const _hoisted_5 = { class: "text-primary-500" }
const _hoisted_6 = {
  key: 0,
  class: "grid grid-cols-1 gap-4 lg:grid-cols-3 lg:gap-6"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "No Available Test Result(s)", -1)
const _hoisted_9 = [
  _hoisted_8
]

import PortalLayout from '@/layouts/PortalLayout.vue';
import TestResultCard from './TestResultCard.vue';
// import TextInput from '@/components/inputs/TextInput.vue';
// import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/vue/24/solid";
// import Paginate from 'vuejs-paginate-next';
import PageLoader from "@/components/PageLoader.vue";

import { useRouter } from 'vue-router';
import { onMounted, ref, computed } from 'vue';
import { BellIcon } from '@heroicons/vue/24/outline';

import patient from "@/classes/UserData";


export default /*#__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {

const router = useRouter();
const loader = ref(false)
const testResult = ref(); //file
const testResults = ref<any[]>([]); //data
const newTestResultCount = ref();
const patientData = computed(() => patient.getCurrentUser())

const pageNumber = ref("1");
const numberOfBookings = ref("9999");
// const testResultStatus = ref([]);

const fetchData = () => {
    loader.value = true
    //balican
    patient.getTestResults(patientData.value.patient_id, pageNumber.value, numberOfBookings.value)
        .then(({data}) => {
            loader.value = false
            
            if (data?.results?.response) {
                testResults.value = data?.results?.response;
                newTestResultCount.value = testResults.value ? testResults.value.length : 0
            } else {
                testResults.value = [];
                 newTestResultCount.value = 0
            }
           
            // setTimeout(() => {
            //     getSelectedTestResults(testResults.value.laboratory_id)
            // }, 100);

            // testResults.value = result.data.results
            // newTestResultCount.value = testResults.value ? testResults.value.length : 0
            // testResultStatus.value = result.data.testResultStatus;
        })
        .catch((err) => {
            loader.value = false
            console.log(err);
            // if(err.response.status == 401) {
            //     window.location.replace('/login')
            // }
        })
}

// const checkReadStatus = (result) => {
//     return testResultStatus.value.find(x => x.laboratory_id == result.laboratory_id).read_at == null;
// }

// const viewTestResult = () => {
//     if(testResult.value.lab_result_base_64) {
//         const decodedString = atob(testResult.value.lab_result_base_64);
//         const uint8Array = Uint8Array.from([...decodedString].map(char => char.charCodeAt(0)));
//         const blob = new Blob([uint8Array], { type: 'application/pdf' });
//         const testResultFile = URL.createObjectURL(blob);

//         const link = document.createElement('a');
//         link.href = testResultFile;
//         link.target = '_blank';
//         link.click();
//     }

// }
const viewTestResult = (bookingId:number):void => {
    router.replace({ name: 'AppointmentShow', params: { id: bookingId } })
}

const getSelectedTestResults = (laboratoryId: any) => {
    loader.value = true
    
    patient.getSelectedTestResults(laboratoryId)
        .then((result: any) => {
            loader.value = false;
            testResult.value = result.data.response;
        })
        .catch((err) => {
            loader.value = false;

            if(err.response.status == 401) {
                window.location.replace('/login');
            }
        })
}

onMounted( () => fetchData())

//  Paginate Products

// const page = ref(1);
// const pages = ref([]);

// const paginate =(pageNumber)=> {
//     page.value = pageNumber;
// }

// const previousPage = (currentPage = 1) => {
//     if (currentPage > 1) {
//         resetPages();
//         page.value = currentPage - 1;
//     }                     
// }

// const nextPage = (currentPage = 1) => {
//     if (currentPage < pages.value.length) {
//         resetPages();
//         page.value = currentPage + 1;
//     }            
// }

// const resetPages = () => {
//     pages.value = [];
// }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PortalLayout, { defaultTitle: false }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", {
          class: "relative cursor-pointer",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(router).push('/notifications')), ["prevent"]))
        }, [
          _createVNode(_unref(BellIcon), { class: "w-7 h-7" }),
          _hoisted_3
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_4, [
        _createTextVNode(" You have "),
        _createElementVNode("strong", _hoisted_5, _toDisplayString(newTestResultCount.value ? newTestResultCount.value : 0) + " new test " + _toDisplayString(newTestResultCount.value > 0 || newTestResultCount.value === 'undefined' ? 'results' : 'result'), 1)
      ]),
      (testResults.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(testResults.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _createVNode(TestResultCard, {
                  onClick: _withModifiers(($event: any) => (viewTestResult(item.booking_id)), ["prevent"]),
                  item: item,
                  badge: false
                }, null, 8, ["onClick", "item"])
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9)),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 2 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})